import styled from "styled-components";
import { Select } from "antd";

export const StyledCheckbox = styled.input.attrs({ type: "checkbox" })`
  width: 16px;
  height: 16px;
  accent-color: #001b36;
  cursor: pointer;
  &:hover {
    accent-color: #001b36;
  }
`;

export const Container = styled.div`
  width: 100%;
  padding: 16px;
  background-color: #fff;
`;

export const FormContainer = styled.div`
  margin: 0 auto;
  width: 100%;
  padding: 16px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const FormSection = styled.div`
  margin-bottom: 32px;
`;

export const SectionTitle = styled.h3`
  color: #002244;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 600;
`;

export const FileSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const FileItem = styled.div`
  padding: 20px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: transparent;
  position: relative;
  width: 100%;
`;

export const SwitchesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;
  margin-top: 35px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0;
  }
`;

export const SwitchContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 230px;
  height: 100%;
  gap: 10px;
  margin-bottom: 24px;

  span {
    color: #314158;
    text-align: center;
    font-family: "Inter", sans-serif;
    font-size: 1rem;
    font-weight: 600;
    margin-right: 8px;
    line-height: 1.2;
  }

  .ant-switch {
    width: 45px;
  }

  .ant-switch-checked {
    background-color: #002244;
  }

  @media (max-width: 1024px) {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 120px;
    width: 100%;
    padding: 0 8px;
    margin-top: 20px;

    span {
      text-align: left;
    }
  }
`;

export const AddNewTranslate = styled.button`
  height: 40px;
  width: auto;
  min-width: 230px;
  color: #002244;
  background: transparent;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 0 !important;
  margin-bottom: 16px;
  padding: 0;

  &:hover:not(:disabled) {
    opacity: 0.8;
    color: #002244;
    background: transparent;
    border: none;
  }

  &:focus:not(:disabled) {
    opacity: 0.8;
    color: #002244;
    background: transparent;
    border: none;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    color: #999;
  }
`;

export const AddFileButton = styled.button`
  height: 40px;
  width: 230px;
  min-width: 230px;
  color: #002244;
  background: transparent;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0 8px;

  &:hover:not(:disabled) {
    opacity: 0.8;
    color: #002244;
    background: transparent;
    border: none;
  }

  &:focus:not(:disabled) {
    opacity: 0.8;
    color: #002244;
    background: transparent;
    border: none;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    color: #999;
  }
`;

export const RemoveFileButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: #fecaca;
  color: #991b1b;
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #fecaca;
    opacity: 0.8;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    color: #999;
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ActionsContainer = styled.div`
  margin-top: 40px;
  padding-top: 24px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;

  button {
    font-size: 14px;
    font-family: "Inter", sans-serif;
    font-weight: 600;
    text-transform: uppercase;
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    margin-top: -5px;
  }

  @media (max-width: 1024px) {
    flex-direction: column;

    button {
      width: 100%;
    }
  }
`;

export const FlowNameContainer = styled.div`
  position: relative;
  width: 100%;

  input {
    padding-left: 40px !important;
  }
`;

export const CountryFlagIcon = styled.img`
  position: absolute;
  left: 12px;
  width: 20px;
  height: 15px;
  border-radius: 2px;
  z-index: 2;
  object-fit: cover;

  /* Posicionamento dinâmico baseado na presença de label */
  ${({ hasLabel }) =>
    hasLabel
      ? `
    /* Com label: posiciona no centro do input considerando label + margin */
    top: calc(18.86px + 8px + 24px);
    transform: translateY(-50%);
  `
      : `
    /* Sem label: posiciona no centro do input apenas */
    top: 24px;
    transform: translateY(-50%);
  `}
`;

export const FileRowContainer = styled.div`
  padding-top: 7px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-wrap: nowrap;
  width: 100%;

  .format-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 8px;
  }

  .format-wrapper > div {
    width: 100%;
  }

  .products-ecommerce > div {
    margin-top: 15px;
    margin-bottom: 5px;
  }

  @media (max-width: 1024px) {
    flex-wrap: wrap;
    .format-wrapper {
      width: 100%;
      min-width: 250px;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    .format-wrapper {
      width: 100% !important;
      min-width: unset !important;
      margin-top: 0 !important;
      align-items: unset !important;
    }
  }
`;

export const CancelButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  margin-top: 24px;
  background: #fecaca;
  border: 1px solid #fecaca;
  color: #991b1b;
  border-radius: 4px;
  padding: 12px 24px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 170px;
  height: 40px;

  &:hover {
    opacity: 0.8;
    background: #fecaca;
    border-color: #fecaca;
    color: #991b1b;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SectionTitleAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  button {
    background: #991b1b;
    border: none;
    cursor: pointer;
    color: #fff;
    border-radius: 4px;
    padding: 10px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    &:hover {
      text-decoration: underline;
      opacity: 0.9;
    }
  }
`;

export const RemoveTranslationButton = styled.button`
  background: transparent;
  border: none;
  color: #dc2626;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  cursor: pointer;
  padding: 12px 16px;
  transition: background-color 0.2s ease;
  white-space: nowrap;
  margin-top: 3px;

  &:disabled {
    color: #999;
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const TranslateWithButton = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;

  > div:first-child {
    flex: 1;
  }

  > button {
    flex-shrink: 0;
    margin-top: 4px;
    align-self: flex-start;
  }
`;

export const IndexCountFiles = styled.div`
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
  line-height: 18.86px;
  letter-spacing: 0%;
  vertical-align: middle;
  padding-bottom: 12px;
`;

export const InfoProductsECommerce = styled.span`
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 12px;
  line-height: 18.86px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #999999;
  margin: 0;
  padding: 0;
  top: 0;
`;

export const InactiveInfo = styled.div`
  font-family: Open Sans;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  width: fit-content;
  font-style: italic;
  text-decoration-style: solid;
  color: #fff;
  background-color: #666666;
  border-radius: 8px;
  padding: 6px;
  align-items: center;
  display: flex;
  gap: 8px;
`;

export const ReturnButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  background-color: rgba(0, 34, 68, 1);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  height: 34px;

  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
  line-height: 25px;
  color: #ffffff;
  font-family: "Open Sans";
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(0, 34, 68, 0.8);
  }
`;

export const ButtonGoBack = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;

  button {
    font-size: 14px;
    font-family: "Inter", sans-serif;
    font-weight: 600;
    text-transform: uppercase;
    width: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    margin-top: -5px;
  }

  @media (max-width: 1024px) {
    flex-direction: column;

    button {
      width: 100%;
    }
  }
`;

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  margin-top: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  padding: 16px;
  width: fit-content;

  span.ant-radio + * {
    &:not(:last-child) {
      padding-right: 8px;
    }
  }

  .ant-radio-wrapper {
    color: #314158;
    font-family: "Open Sans", sans-serif;
    font-size: 12px;
    font-weight: 600;
    line-height: 18.86px;

    &:not(:last-child) {
      margin-right: 8px;
    }
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: #002244;
    background-color: #ffffff;
  }

  .ant-radio:hover .ant-radio-inner {
    border-color: #002244;
  }

  .ant-radio-inner::after {
    background-color: #002244;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

export const SelectSalesforceProducts = styled(Select)`
  .ant-select-selector {
    min-height: 56px !important;
    height: auto !important;
    border-radius: 5px !important;
    display: flex;
    align-items: center;
    margin-bottom: 8px !important;
    margin-top: 8px !important;
    padding: 8px 12px !important;
  }

  .ant-select-selection-overflow {
    flex-wrap: wrap !important;
    gap: 4px !important;
  }

  .ant-select-selection-item {
    margin: 2px 4px !important;
    max-width: 100%;
  }

  .ant-select-selection-placeholder {
    line-height: 56px !important;
    padding: 0 12px !important;
    color: rgba(0, 0, 0, 0.85);
  }

  .ant-select-selection-search {
    margin-inline-start: 4px !important;
  }
`;

export const SelectTitle = styled.span`
  font-family: Open Sans;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 18.86px;
  letter-spacing: 0%;
  vertical-align: middle;
`;

export const DocumentsErrorMessage = styled.span`
  color: #dc2626;
  font-size: 10px;
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 600;
  line-height: 18.86px;
  font-family: "Open Sans", sans-serif;
`;
